import { createRoot } from 'react-dom/client';
import VideoPlayer from 'react-video-js-player';
import '../../../common/polyfills';
import '../Style/Video.scss';
import MiniVideoPlayer from './LittleVideoPlayer';

export interface IVideoProps extends IVideoAttributes {
	videoUrl: string;
	videoTextSections?: { Header: string; Delay: number; Description: string }[];
	videoId: string;
	width: number;
	height?: number;
	poster?: string;
	isMacro?: boolean;
}

interface IVideoAttributes {
	isAutoPlay: boolean;
	isMuted: boolean;
	isLoop: boolean;
	isShowControls: boolean;
}

const isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); /*&&
  !window.MSStream*/

function IOSVideoPlayer(props: IVideoProps) {
	const videoWidth = props.width && props.width != undefined && props.width > 0 ? `${props.width}px` : '60%';
	return (
		<VideoPlayer
			controls={true}
			autoplay={props.isAutoPlay}
			src={props.videoUrl}
			poster={props.poster}
			width={videoWidth}
			height={props.height}
		/>
	);
}

function StandardVideoPlayer(props: IVideoProps) {
	const videoWidth = props.width && props.width != undefined && props.width > 0 ? `${props.width}px` : '80%';

	return (
		<video
			id={props.videoId}
			src={props.videoUrl}
			preload="auto"
			className="video"
			autoPlay={props.isAutoPlay}
			controls={props.isShowControls}
			loop={props.isLoop}
			muted={props.isMuted}
			playsInline
			style={{ width: videoWidth, height: props.height }}
		>
			The video content is not supported.
		</video>
	);
}

export const Video = (props: IVideoProps) => {
	return <div className="videoSection">{isIOS ? <IOSVideoPlayer {...props} /> : <StandardVideoPlayer {...props} />}</div>;
};

export default Video;

export function MountVideo(props: any, el: Element) {
	const VideoComponent = props.isMini ? MiniVideoPlayer : Video;
	const root = createRoot(el);
	root.render(<VideoComponent {...props} />);
}
